<template>
<div class="chapter">
<div class="inner_page">
<div>
<p class="dedication" lang="en-US"><span class="Italic-Style" lang="en-US">For René, of course</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9781504084895-1.vue?ea3a45fa